"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERISCOPE_ENTITY_COPY = void 0;
exports.PERISCOPE_ENTITY_COPY = {
    IS_LOOKUP_OF_OBJECT: (name, objectName) => `${name} is a lookup of the ${objectName} object`
};
//# sourceMappingURL=COPY.js.map